interface AccountKey {
  key: string;
  accountType: string;
  sourceType: string;
  accountId: string;
}

interface Category {
  name: string;
  resourceKey: string;
  resourceBundle: string | null;
}

interface Account {
  yearToDateInterest: string;
  interestAccrued: string;
  nextPaymentDate: string;
  totalPaymentAmountsSinceLastStatement: number;
  creditLimit: number;
  lastRenewalDate: string;
  dueDate: string;
  paymentAmountNative: number;
  accountKey: AccountKey;
  accountName: string;
  displayName: string;
  alias: string | null;
  availableBalance: number;
  bankingCoreErrorMessage: string | null;
  category: Category;
  cls: string;
  currency: string;
  currencySymbol: string;
  currentBalance: number;
  currentFeeAmount: number | null;
  currentInterestBalance: number | null;
  currentLateChargeBalance: number | null;
  currentPrincipalBalance: number | null;
  group: string;
  idAccount: string;
  isBlocked: boolean;
  isDisplayAlias: boolean;
  isPermittedTransactionThresholdsRequired: boolean;
  isPermittedTransferFrom: boolean;
  isPermittedTransferTo: boolean;
  isPermittedTwoSignatureRequired: boolean;
  isPermittedChangePin: boolean;
  isPermittedResetPin: boolean;
  isVisible: boolean;
  minimumPaymentDue: boolean;
  payoffAmountNative: number;
  pendingCredit: number | null;
  primary: boolean;
  processor: null;
  status: string;
  totalCurrentDueBalance: string;
  totalPastDueBalance: number | null;
  lastPaymentDate: string | null;
}

interface SortedAccounts {
  allAccounts : Account[];
  visibleAccounts : Account[];
  deposits : Account[];
  loans : Account[];
  ccs : Account[];
}

export { Account, SortedAccounts, AccountKey, Category };


export enum CardSourceType {
  BEVERTEC = "BT",
  I2CD = "I2CD",
  I2C = "I2C",
}